// Schema for template pages — design canvases for popup objects.
// Only id and comment are exposed in the properties panel.
// bg_color/border/swipe/touch/hidden are intentionally excluded.
export const template_page = {
    // A screen, like page.js — never clickable, so never focusable.
    focusable: false,

    parts: {},

    properties: {
        x: { type: 'int', internal: true },
        y: { type: 'int', internal: true },
    },

    defaults: { properties: { x: 0, y: 0 } },

    editorCapabilities:  ['has_objectmenu'],
    runtimeCapabilities: [],

    events:   {},
    bindings: { properties: {}, actions: { hass_services: [] }, events: {} },
}
